import { Flex, Panel, Text, UserAvatar } from 'components'
import { useBreakpoint, useTheme, useUser } from 'utils'
import { OnTheGoAnalyticsBar } from '.'
import { useOnTheGo } from '../../utils'

export default function OnTheGoMemberBanner() {
  const { memberId } = useOnTheGo()
  const user = useUser(memberId)
  const { theme } = useTheme()
  const isMobile = useBreakpoint() < 2

  if (!user) return null

  return (
    <Panel
      {...(isMobile && { borderRadius: 'none' })}
      backdropFilter="none"
      overflow="hidden"
      flexShrink={0}
      flexDirection="column"
    >
      <Flex
        bg={theme == 'light' ? 'rgba(255, 255, 255, 0.44)' : ''}
        borderBottomWidth={theme == 'light' ? 'none' : '1px solid rgba(255, 255, 255, 0.15)'}
        align={{ base: 'stretch', lg: 'center' }}
        gap={4}
        p={{ base: 2, lg: 6 }}
      >
        <UserAvatar hideTooltip size={isMobile ? 'lg' : '2xl'} user={user} />
        <Flex direction="column" flex={1} gap={1} minW={0}>
          <Text textStyle={isMobile ? 'h6' : 'h2'} truncate>
            {user?.displayName || 'Member'}
          </Text>
          <Text opacity={0.8} textStyle="bodyMedium" truncate>
            {user?.email}
          </Text>
        </Flex>
        <OnTheGoAnalyticsBar />
      </Flex>
    </Panel>
  )
}
